<template>
	<svg @click='$emit("click")' class='icon'>
		<use :xlink:href='`#icon-${iconName}`' />
	</svg>
</template>

<script>
export default {
	name:       'icon',
	props: ['icon-name']
};
</script>
